import { enableProdMode } from '@angular/core';
import { loadLeaflet } from '@vectronic/base-map';
import { Buffer } from 'buffer';
import { DesktopInterceptor } from './app/services/interceptors/desktop-interceptor';
import { environment } from './environments/environment';

const { production, useAuthInterceptor, username, desktop, mobile } = environment;

if (mobile) {
  console.log('[main.ts] Mobile environment bootstrap started.');
  (window as any).global = window;
  (window as any).Buffer = Buffer;
  (window as any).process ??= {
    env: {},
    platform: 'browser',
    nextTick: (fn: any, ...args: any[]) => setTimeout(() => fn(...args), 0),
  };
}

if (production) enableProdMode();
else if (useAuthInterceptor && !localStorage.getItem('currentlyLoggedInUser')) {
  localStorage.setItem('currentlyLoggedInUser', username);
}

if (desktop) {
  DesktopInterceptor.init();
  window.desktop.user
    .get()
    .subscribe(({ email }) => localStorage.setItem('currentlyLoggedInUser', email));
}

loadLeaflet().then(() => import('./bootstrap').catch((err) => console.error(err)));
